/**
 *
 * OtherServiceDetailsPage
 *
 */
import { OfflineServiceQueryStringParameters } from '../Details/slice/types';
import { RouteComponentProps, useLocation } from 'react-router-dom';
import { OtherServiceDetails } from '../Details';
import { getParams } from './getQueryStringParameter';
import { RenderPageType } from 'app/Layout/FrontendLayout/slice/type';
import { Button } from 'app/components/BasicButtons/Button';
import useSidePanelState, {
  SidePanelOpenState,
} from 'app/hooks/useSidePanelOpen';
import * as React from 'react';
import { IOtherServices } from 'app/pages/OtherServicesPage/IOtherServices';

export interface OtherServiceDetailsPageProps<
  Params extends {
    [K in keyof OfflineServiceQueryStringParameters]?: string | undefined;
  } = {}
> extends RouteComponentProps<Params> {}
export function OtherServiceDetailsPage(props: OtherServiceDetailsPageProps) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const queryProps = getParams(params, props);
  return <OtherServiceDetails useSidePanel={false} queryParams={queryProps} />;
}
export function OtherServiceEditLink(props: {
  id: number;
  useSidePanel: boolean;
  service?: IOtherServices;
  openPanelWithCover?: (state: SidePanelOpenState) => void;
}) {
  const { openPanel } = useSidePanelState();
  const handleOfflineServiceClick = React.useCallback(() => {
    let otherProps = {
      initialService: props.service,
      queryParams: {
        id: '' + props.id ?? -1,
      },
      useSidePanel: true,
    };
    const panelProps = {
      renderPageType: RenderPageType.OtherServiceDetails,
      renderPageProps: otherProps,
      expanded: false,
      useSidePanel: props.useSidePanel,
      isCover: props.useSidePanel,
    } as SidePanelOpenState;
    !!props.openPanelWithCover
      ? props.openPanelWithCover(panelProps)
      : openPanel(panelProps);
  }, [openPanel, props]);
  return (
    <Button
      variant="text"
      size="small"
      onClick={() => handleOfflineServiceClick()}
    >
      {props.id}
    </Button>
  );
}
